const footerLinks = [
  { href: '#today', label: '今日更新' },
  { href: '#ranking', label: '热播榜' },
  { href: '#new', label: '新片上映' },
  { href: '#theater', label: '院线同步' },
  { href: '#highrated', label: '高分推荐' },
  { href: '#genres', label: '类型浏览' },
  { href: '#guide', label: '选片指南' },
  { href: '#faq', label: '常见问题' },
];

const keywordTags = [
  '九七电影院最新电影',
  '九七电影院热播榜',
  '九七电影院新片上映',
  '九七电影院今日更新',
  '九七电影院院线同步',
  '九七电影院高分推荐',
];

export default function SiteFooter() {
  return (
    <footer className="w-full bg-primary-950 px-4 py-12 text-background-100 md:px-6 md:py-14">
      <div className="mx-auto max-w-6xl">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-[1.4fr_1fr_1fr]">
          <div>
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-film-line text-lg" aria-hidden="true"></i>
              </span>
              <span className="font-heading text-lg font-bold text-background-50">九七电影院</span>
            </div>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-background-100/70">
              一个把影视资讯整理在一起的单页站点：今日更新、热播榜、新片上映、院线同步与高分推荐都集中在这一页。
              我们不提供播放，只帮你更快看清有哪些值得关注的影片。
            </p>
          </div>

          <nav aria-label="页脚分区导航">
            <h2 className="font-heading text-sm font-bold text-background-50">页面导航</h2>
            <ul className="mt-4 grid grid-cols-2 gap-2">
              {footerLinks.map((link) => (
                <li key={link.href}>
                  <a
                    href={link.href}
                    className="text-sm text-background-100/70 transition-colors hover:text-background-50"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </nav>

          <div>
            <h2 className="font-heading text-sm font-bold text-background-50">内容方向</h2>
            <ul className="mt-4 flex flex-wrap gap-2">
              {keywordTags.map((tag) => (
                <li key={tag} className="rounded-full bg-primary-900 px-3 py-1 text-xs text-background-100/75">
                  {tag}
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-background-50/15 pt-6 text-xs text-background-100/60 sm:flex-row sm:items-center sm:justify-between">
          <p>© {new Date().getFullYear()} 九七电影院 · 影视资讯聚合页面</p>
          <p>页面信息仅为浏览参考，具体上映与播放安排请以正规渠道为准。</p>
        </div>
      </div>
    </footer>
  );
}